import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { importSpreadsheetInterface } from 'src/app/util/interfaces/importSpreadsheetInterface';
import { spreadsheetInterface } from 'src/app/util/interfaces/spreadsheet';
import * as XLSX from 'xlsx';
import { DateService } from '../date/date.service';
import { ShkDate } from 'shk-date';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {
	wscols: XLSX.ColInfo[] = [];

	constructor(private DateService: DateService) {}

	public exportAsExcelFile(json: any[], excelFileName: string): void {
		const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json, { skipHeader: true });
		const workbook: XLSX.WorkBook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
		const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
		this.saveAsExcelFile(excelBuffer, excelFileName);
	}

	saveAsExcelFile(buffer: any, fileName: string): void {
		const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
		FileSaver.saveAs(data, fileName + Date.now() + EXCEL_EXTENSION);
	}

	convertSpreadsheetToXLSX(spreadsheet: spreadsheetInterface, excelName: string): void {
		const returnJSON: any[][] = [];
		for (let index = 0; index < spreadsheet.lines.length; index++) {
			if (!spreadsheet.lines[index].generatedBlank) {
				const newCellString = [];
				for (let index_ = 0; index_ < spreadsheet.lines[index].cells.length; index_++) {
					newCellString.push(spreadsheet.lines[index].cells[index_].item_name);
				}
				returnJSON.push(newCellString);
			}
		}

		this.exportAsExcelFile(returnJSON, excelName);
	}

	public exportExcel(spreadsheet: spreadsheetInterface, excelName: string): void {
		this.convertSpreadsheetToXLSX(spreadsheet, excelName);
	}

	arrayBuffer: any;
	holdIncomingFile: File;
	public incomingfile(event) {
		this.holdIncomingFile = event.target.files[0];
	}

	public importExcel(): Promise<importSpreadsheetInterface> {
		return new Promise<importSpreadsheetInterface>((resolve, reject) => {
			const fileReader = new FileReader();
			fileReader.addEventListener('load', (e) => {
				this.arrayBuffer = fileReader.result;
				const data = new Uint8Array(this.arrayBuffer);
				const array = [];
				for (let index = 0; index != data.length; ++index) array[index] = String.fromCharCode(data[index]);
				const bstr = array.join('');
				const workbook = XLSX.read(bstr, { type: 'binary', cellDates: true });

				const excelFile: importSpreadsheetInterface = {
					sheetNameList: [...workbook.SheetNames],
					sheets: {},
				};

				for (const sheetName of workbook.SheetNames) {
					excelFile.sheets[sheetName] = {
						columns: [],
						data: [],
					};
					excelFile.sheets[sheetName].columns = [];
					let header = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1, raw: false });
					header = <string[]>header[0];
					header.forEach((headerName: string) => {
						excelFile.sheets[sheetName].columns.push(headerName);
					});

					const worksheet = workbook.Sheets[sheetName];
					const worksheetData = XLSX.utils.sheet_to_json(worksheet, { raw: true });
					excelFile.sheets[sheetName].data = [];
					for (const row of worksheetData) {
						const temporary = [];
						for (const columnName of excelFile.sheets[sheetName].columns) {
							if (row[columnName] instanceof Date)
								temporary.push(this.DateService.formatDate(new ShkDate(row[columnName]).date));
							else if (row[columnName]) temporary.push(row[columnName]);
							else temporary.push('');
						}
						excelFile.sheets[sheetName].data.push([...temporary]);
					}
				}

				resolve(excelFile);
			});

			fileReader.readAsArrayBuffer(this.holdIncomingFile);
		});
	}

	convertMspTableInto2d(header: mspTableHeaderI[], body: any[]): any[][] {
		const returnData = [];
		const temporary = [];
		header.forEach((header) => {
			temporary.push(header.value);
		});
		returnData.push(JSON.parse(JSON.stringify(temporary)));
		for (const line of body) {
			const temporary_ = [];
			header.forEach((header) => {
				temporary_.push(line[header.name]);
			});
			returnData.push(JSON.parse(JSON.stringify(temporary_)));
		}

		return returnData;
	}
}
